<script lang="ts">
  import { page } from '$app/stores';

  export let loginText = 'Sign in';
  export let loginHint = '';
  export let className = '';

  $: target = $page.url.toString();
  $: query = loginHint ? `loginHint=${loginHint}&target=${target}` : `target=${target}`;
</script>

<a href="/oauth/login?{query}" class={className} rel="external">
  {loginText}
</a>
